import {
  TeamOutlined,
  LogoutOutlined,
  UserOutlined,
  SolutionOutlined,
  DatabaseOutlined,
  UsergroupAddOutlined,
  UserSwitchOutlined,
  BookOutlined,
} from "@ant-design/icons";
import { RouteNames } from "../../router";

export const items = (t: Function) => [
  {
    label: "Products",
    icon: <DatabaseOutlined />,
    key: "Products",
    children: [
      {
        label: "EXECUTIVE COMPENSATION",
        key: "/executiveCompensation",
        icon: <SolutionOutlined />,
      },
      {
        label: "BOARD OF DIRECTORS PAY",
        key: "/boardOfDirectorsPay",
        icon: <UsergroupAddOutlined />,
      },
      {
        label: "ESG",
        key: "/esg",
        icon: <UserSwitchOutlined />,
      },
      {
        label: "DIGITAL SOLUTION",
        key: "/digitalSolution",
        icon: <SolutionOutlined />,
      },
    ],
  },
  {
    label: t("about us"),
    icon: <TeamOutlined />,
    key: "aboutUs",
    children: [
      {
        label: t("our team"),
        key: "/aboutUs",
        icon: <SolutionOutlined />,
      },
    ],
  },
  {
    label: t("articles"),
    key: "/articles",
    icon: <BookOutlined />,
  },
  {
    label: t("login"),
    key: RouteNames.LOGIN,
    icon: <UserOutlined />,
  },
];

export const itemsAuth = (t: Function) => [
  {
    label: "Products",
    icon: <DatabaseOutlined />,
    key: "Products",
    children: [
      {
        label: "EXECUTIVE COMPENSATION",
        key: "/executiveCompensation",
        icon: <SolutionOutlined />,
      },
      {
        label: "BOARD OF DIRECTORS PAY",
        key: "/boardOfDirectorsPay",
        icon: <UsergroupAddOutlined />,
      },
      {
        label: "ESG",
        key: "/esg",
        icon: <UserSwitchOutlined />,
      },
      {
        label: "Digital Solution",
        key: "/digitalSolution",
        icon: <SolutionOutlined />,
      },
    ],
  },
  {
    label: t("about us"),
    icon: <TeamOutlined />,
    key: "aboutUs",
    children: [
      {
        label: t("our team"),
        key: "/aboutUs",
        icon: <SolutionOutlined />,
      },
    ],
  },
  {
    label: t("articles"),
    key: "/articles",
    icon: <BookOutlined />,
  },
  {
    label: t("logout"),
    key: "/logout",
    icon: <LogoutOutlined />,
  },

  // {
  //   label: t("press"),
  //   key: "/press",
  //   icon: <ReadOutlined />,
  // },
  // {
  //   label: t("panel"),
  //   key: "/panel",
  //   icon: <FormOutlined />,
  // },
  // {
  //   label: t("setting"),
  //   key: "/setting",
  //   icon: <SettingOutlined />,
  // },
];
